export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7741.55f5d79d.jpg";